export default __webpack_public_path__ + "static/media/TONI&JAY-5881.d42aae63.jpg";